// extracted by mini-css-extract-plugin
export default {"timer":"IdleTimer_timer__mUSIA","title":"IdleTimer_title__KHz55","subTitle":"IdleTimer_subTitle__DbQSC","button":"IdleTimer_button__sALFc"};